export default __webpack_public_path__ + "static/MustafaBensan-c0bf117624f34b0b1dbeb144f314269c.jpg";